import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function AwardFlightFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M8.42531 16.0707C8.52315 16.1254 8.62229 16.178 8.72266 16.2282C9.71486 16.7251 10.8277 17 12 17C13.1735 17 14.2869 16.7305 15.2792 16.2398C15.3917 16.1842 15.5027 16.1257 15.612 16.0645C17.9239 14.7692 19.5 12.2341 19.5 9.12695C19.4998 5.22428 16.1767 2 12 2C7.82335 2 4.50023 5.22428 4.5 9.12695C4.5 12.2041 6.09419 14.7663 8.42531 16.0707ZM13.036 6.83478C13.3619 6.50874 14.0435 5.85546 14.3498 5.68401C14.749 5.46055 15.1485 5.41771 15.5922 5.68401C15.6318 5.70779 15.665 5.74097 15.6888 5.7806C15.9587 6.23059 15.9145 6.62982 15.6888 7.02805C15.5163 7.33233 14.8626 8.01154 14.5374 8.33684L13.9744 8.90017L15.0211 11.5799C15.115 11.9365 15.0124 12.3162 14.7517 12.577L14.4452 12.8835C14.385 12.9436 14.301 12.9734 14.2165 12.9644C14.1319 12.9555 14.056 12.9088 14.0098 12.8374L12.2853 10.4023L11.1593 11.5288L11.3727 12.6532C11.3821 12.7383 11.3525 12.823 11.2919 12.8835L10.7581 13.4175C10.6941 13.4815 10.6032 13.5109 10.5139 13.4964C10.4246 13.4819 10.3477 13.4253 10.3072 13.3444L9.54838 11.8262L8.03064 11.0672C7.94969 11.0267 7.89313 10.9497 7.87864 10.8604C7.86414 10.771 7.89348 10.6801 7.95748 10.6161L8.49136 10.0821C8.55183 10.0216 8.6365 9.99187 8.72149 10.0013L9.84558 10.2145L10.9716 9.08801L8.53749 7.36361C8.46611 7.3174 8.41942 7.24139 8.41046 7.15681C8.4015 7.07222 8.43124 6.98811 8.49136 6.92797L8.79788 6.62142C9.05857 6.36066 9.43809 6.25804 9.79459 6.35188L12.473 7.39813L13.036 6.83478Z"
				fill="currentColor"
			/>
			<path
				d="M15.2792 16.2398C15.3917 16.1842 15.5027 16.1257 15.612 16.0645L15.2597 16.123L15.2792 16.2398ZM8.42531 16.0707C8.52315 16.1254 8.62229 16.178 8.72266 16.2282L8.74021 16.123L8.42531 16.0707Z"
				fill="currentColor"
			/>
			<path
				d="M16.9431 17.0944C16.503 17.3862 16.0363 17.639 15.5474 17.8491C14.4591 18.3167 13.2607 18.5723 12 18.5723C10.7394 18.5723 9.54147 18.3124 8.4538 17.8398C7.96536 17.6275 7.49916 17.3723 7.0595 17.0784L6.25975 21.877C6.2169 22.1347 6.3121 22.3964 6.50975 22.5674C6.70745 22.7382 6.97963 22.7935 7.2285 22.7139L12 21.1865L16.7715 22.7139L16.8652 22.7383C17.0869 22.7788 17.3171 22.7169 17.4902 22.5674C17.6632 22.4178 17.7579 22.1987 17.75 21.9736L17.7402 21.877L16.9431 17.0944Z"
				fill="currentColor"
			/>
		</svg>
	);
}

AwardFlightFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default AwardFlightFilledIcon;
